export default __webpack_public_path__ + "static/media/HappyInTheDark.9eb75961.mp3";